// extracted by mini-css-extract-plugin
export default {"wrapper":"Payment_wrapper__+yyib","purpleBackground":"Payment_purpleBackground__aXv+F"};